import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Button,
} from "reactstrap";
import {
  Link
} from "react-router-dom";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import Select from "react-dropdown-select";
import { toast } from 'react-toastify';
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay'
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Scrollbars } from 'react-custom-scrollbars';
import ImageMappingService from '../../services/api/MachineImages';
import { cloudTypeLogo } from "settings/shared/commonMethod";


const styles = {
  errorBox: {
    textAlign: "center",
    marginBottom: 20
  },
  error: {
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    backgroundColor: "rgb(249, 228, 228)",
    padding: "6px 200px 6px 250px",
    borderRadius: 6
  },
  passwordHint: {
    color: "#000",
    fontSize: 12
  }
}
class newimagemapping extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      errorSubmitted: false,
      mode: '',
      name: '',
      Description: '',
      errorMessage: '',
      editId: "",
      lockstatus: false,
      editFlag: false,
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      Architecture: 'X_86',
      // Architecture: '',
      cloudOptions: [],
      cloudType: "",
      regionName: "",
      ImageType: "",
      ImageId: "",
      regionOptions: [],
      architectureOptions: [],
      imageTypeOptions: [],
      zone: "",
      zoneOptions: []
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    let mode = this.props.location.state.mode;
    if (mode === "editImageMapping") {
      this.EditCloudImages(this.props.location.state.EditData.id);
    }
    else {
      this.setState({
        btnActions: "Create",
        cloudType: ""
      });
    }
    this.getCloudOption();
    this.getArchitecture();
    this.getImageType();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight });
  }
  getArchitecture = () => {
    ImageMappingService.getArchitecture()
      .then((response) => {
        let architectureData = response.architecture;
        var aoptions = [];
        if (architectureData !== null && architectureData !== undefined && architectureData.length > 0) {
          aoptions = architectureData.map((item, index) => {
            return (
              { label: item, value: item }
            )
          })
          this.setState({
            architectureOptions: aoptions,
            loading: false,
          })
        }

      }).catch((error) => {
        this.setState({ loading: false });
      })

  }
  getImageType = () => {
    ImageMappingService.getImageType()
      .then((response) => {
        let ImageTypeData = response.imageType;
        var imgoptions = [];
        if (ImageTypeData !== null && ImageTypeData !== undefined && ImageTypeData.length > 0) {
          imgoptions = ImageTypeData.map((item, index) => {
            return (
              { label: item, value: item }
            )
          })
          this.setState({
            imageTypeOptions: imgoptions,
            loading: false,
          })
        }
      }).catch((error) => {
        this.setState({ loading: false });
      })

  }
  getCloudOption = () => {
    this.state.cloudOptions = [
      { label: <div><img className="" src={cloudTypeLogo("AWS")} />&nbsp; AWS</div>, value: "AWS" },
      { label: <div><img className="" src={cloudTypeLogo("GOOGLE")} />&nbsp; GOOGLE</div>, value: "GOOGLE" },
      // { label: <div><img className="" src={cloudTypeLogo("AZURE")} />&nbsp; AZURE</div>, value: "AZURE" },
    ];
  }
  // Edit MachineType
  EditCloudImages(id) {
    this.setState({
      loading: true,
      btnActions: "Update",
      editId: id,
    });
    ImageMappingService.getCloudImagesById(id)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let cloudImagesData = response.cloudImagesDTO;
          this.setState({
            name: cloudImagesData.name,
            Description: cloudImagesData.description,
            cloudType: cloudImagesData.cloudType,
            regionName: cloudImagesData.region,
            zone: cloudImagesData.zone,
            ImageType: cloudImagesData.imageType,
            Architecture: cloudImagesData.architecture,
            ImageId: cloudImagesData.imageId,
            loading: false
          })
          this.state.ImageType = cloudImagesData.imageType;
          this.state.cloudType = cloudImagesData.cloudType;
          this.state.regionName = cloudImagesData.region;
          this.state.zone = cloudImagesData.zone;
          this.state.Architecture = cloudImagesData.architecture;
          this.state.ImageId = cloudImagesData.imageId;

        } else {
          this.setState({ loading: false });
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }
      }).catch((error) => {
        this.setState({ loading: false });
      })
  }
  setErrorMessage(message) {
    if (message == "") {
      this.setState({
        errorMessage: message,
        errorSubmitted: false
      })
    } else {
      document.getElementById('errorDiv').scrollIntoView()
      this.setState({
        errorMessage: message,
        errorSubmitted: true
      });
    }
  }
  // Submit New Connection Data
  CreateNewImageMapping = (event) => {
    event.preventDefault();
    if ((this.state.name == "" || this.state.name == undefined)) {
      this.setErrorMessage("Please Enter Name");
    }
    else if (this.state.cloudType === "") {
      this.setErrorMessage("Please Select Cloud Type");
    }
    else if (this.state.regionName === "") {
      this.setErrorMessage("Please Select Region Name");
    }
    else if (this.state.zone === "") {
      this.setErrorMessage("Please Select Zone");
    }
    else if (this.state.ImageType === "") {
      this.setErrorMessage("Please Select Image Type");
    }
    else if (this.state.ImageId === "") {
      this.setErrorMessage("Please Enter Image Id");
    }
    else if (this.state.Architecture === "") {
      this.setErrorMessage("Please Select Architecture");
    }
    else {
      if (this.state.editId !== "") {
        this.UpdateImageMapping();
      } else {
        this.PostImageMapping();
      }
    }
  }
  PostImageMapping = () => {
    this.setErrorMessage("");
    if (!this.state.errorSubmitted) {
      let post = {}
      post = {
        active: true,
        name: this.state.name,
        description: this.state.Description,
        imageType: this.state.ImageType,
        cloudType: this.state.cloudType,
        region: this.state.regionName,
        zone: this.state.zone,
        architecture: this.state.Architecture,
        imageId: this.state.ImageId,
      }
      ImageMappingService.PostCloudImage(post)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Cloud Images Created Successfully!</b></i>);
            this.props.history.push('/cloud/imagemapping/');
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
          }
        }
        );
    } else {
      console.error('Invalid Form')
    }
  }
  UpdateImageMapping = () => {
    this.setErrorMessage("");
    if (!this.state.errorSubmitted) {
      let post = {}
      post = {
        active: true,
        name: this.state.name,
        description: this.state.Description,
        imageType: this.state.ImageType,
        cloudType: this.state.cloudType,
        region: this.state.regionName,
        zone: this.state.zone,
        architecture: this.state.Architecture,
        imageId: this.state.ImageId,
      }
      ImageMappingService.updateCloudImage(post, this.state.editId)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Cloud Images Updated Successfully!</b></i>);
            this.props.history.push('/cloud/imagemapping/');
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
          }
        }
        );
    } else {
      console.error('Invalid Form')
    }
  }
  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }
  handleChangecloudType = (event) => {
    if (event.length > 0) {
      let eventItem = event[0];
      this.setState({
        cloudType: eventItem.value,
        zone: ""
      });
      let lowercasecloudType = eventItem.value.toLowerCase()
      ImageMappingService.getimageRegionName(lowercasecloudType)
        .then((response) => {
          let RegionData = response.instanceTypeAliasRegionDTO;
          if (RegionData !== null && RegionData !== undefined && RegionData.length > 0) {
            let regionTypes = RegionData
            var regionarray = regionTypes.map((item, index) => {
              return (
                { label: <div><b>{item.region}</b></div>, value: item.region }
              )
            })
            this.setState({
              regionOptions: regionarray,
              loading: false,

            })
          }
        }).catch((error) => {
          this.setState({ loading: false });
        })
    }
  }
  handleChangeregionName = (event) => {
    if (event.length > 0) {
      let eventItem = event[0];
      this.setState({
        regionName: eventItem.value,
      });
      let zoneName = eventItem.value;
      ImageMappingService.getZoneName(zoneName).then((response) => {
        var zoneopt = [];
        let zoneData = response.zoneNames;
        if (zoneData !== null && zoneData !== undefined && zoneData.length > 0) {
          zoneopt = zoneData.map((item, index) => {
            return (
              { label: item, value: item }
            )
          })
          this.setState({
            zoneOptions: zoneopt,
            loading: false,
          })
        }
      })
    }

  }

  handleZoneName = (event) => {
    if (event.length > 0) {
      this.setState({
        zone: event[0].value,
      });
    }
  }
  handleChangeimageType = (event) => {
    if (event.length > 0) {
      this.setState({
        ImageType: event[0].value,
      });
    }
  }
  handleChangeArchitecture = (event) => {
    if (event.length > 0) {
      this.setState({
        Architecture: event[0].value,
      });
    }
  }

  cancelClick = () => {
    this.props.history.push('/cloud/imagemapping/');
  }
  render() {
    const { errors } = this.state;
    return (

      <>
        <PanelHeader
          content={
            <div className="header text-center">

            </div>
          }
        />
        <div className="content">
          <LoadingOverlay
            active={this.state.loading}
            spinner={<ScaleLoader
              height={35}
              width={5}
              radius={2}
              margin={2}
              color={"#123abc"}
              loading={this.state.loading}
            />}
          >
            <Col xs={12} md={12}>
              <Row>
                <div className=" col" id="errorDiv">
                  <Card className=" shadow">
                    <CardHeader className=" bg-transparent">
                      <Row className="align-items-center">
                        <div className="col">
                          {this.state.editId !== "" && <h5 className="mb-0">Update Cloud Image</h5>}
                          {this.state.editId === "" && <h5 className="mb-0">New Cloud Image</h5>}
                        </div>
                        <div className="col text-right">
                          <Link to="imagemapping" >
                            <span className="close clear-filter">×</span>
                          </Link>

                        </div>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <div className="carcontent">
                        <Scrollbars autoHeight autoHeightMin={this.state.sheight - 200}>

                          {this.state.errorSubmitted &&
                            <div style={styles.errorBox}>
                              <span style={styles.error}>{this.state.errorMessage}</span>
                            </div>
                          }
                          <Form onSubmit={this.CreateNewImageMapping} noValidate>
                            <div className="pl-lg-4">
                              <Row>
                                <Col lg="6">
                                  <FormGroup>
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-email"
                                    >
                                      Name
                                    </label>
                                    <Input
                                      className="form-control"
                                      placeholder="Name"
                                      name="name"
                                      value={this.state.name}
                                      type="text"
                                      onChange={this.handleChange} />
                                  </FormGroup>
                                </Col>
                                <Col lg="6">
                                  <FormGroup>
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-email"
                                    >
                                      Description
                                    </label>
                                    <Input
                                      className="form-control"
                                      placeholder="Description"
                                      name="Description"
                                      value={this.state.Description}
                                      type="text"
                                      onChange={this.handleChange} />
                                  </FormGroup>
                                </Col>
                              </Row>

                              <Row>
                                <Col lg="12">
                                  <FormGroup>
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-username"
                                    >
                                      Cloud Type
                                    </label>
                                    <Select name="cloudType" className="form-control"
                                      values={this.state.cloudOptions.filter(item => item.value === this.state.cloudType)}
                                      options={this.state.cloudOptions}
                                      onChange={(e) => { this.handleChangecloudType(e) }}
                                      noValidate></Select>
                                  </FormGroup>

                                </Col>
                              </Row>
                              <Row>
                                <Col lg="6">
                                  <FormGroup>
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-username"
                                    >
                                      Region Name
                                    </label>
                                    <Select name="regionName" className="form-control"
                                      values={this.state.regionOptions.filter(item => item.value === this.state.regionName)}
                                      onChange={(e) => { this.handleChangeregionName(e) }} options={this.state.regionOptions} noValidate></Select>
                                  </FormGroup>

                                </Col>
                                <Col lg="6">
                                  <FormGroup>
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-username"
                                    >
                                      Zone
                                    </label>
                                    <Select name="zone" className="form-control"
                                      values={this.state.zoneOptions.filter(item => item.value === this.state.zone)}
                                      onChange={(e) => { this.handleZoneName(e) }} options={this.state.zoneOptions} noValidate></Select>
                                  </FormGroup>

                                </Col>
                              </Row>
                              <Row>
                                <Col lg="6">
                                  <FormGroup>
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-username"
                                    >
                                      Image Type
                                    </label>
                                    <Select name="ImageType" className="form-control"
                                      values={this.state.imageTypeOptions.filter(item => item.value === this.state.ImageType)}
                                      options={this.state.imageTypeOptions}
                                      onChange={(e) => { this.handleChangeimageType(e) }}
                                      noValidate></Select>
                                  </FormGroup>

                                </Col>
                                <Col lg="6">
                                  <FormGroup>
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-email"
                                    >
                                      Image Id
                                    </label>
                                    <Input
                                      className="form-control"
                                      placeholder="Image Id"
                                      name="ImageId"
                                      value={this.state.ImageId}
                                      type="text"
                                      onChange={this.handleChange} />
                                  </FormGroup>
                                </Col>
                              </Row>

                              <Row>
                                <Col lg="12">
                                  <FormGroup>
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-email">
                                      Architecture
                                    </label>
                                    <Select name="Architecture" className="form-control"
                                      values={this.state.architectureOptions.filter(item => item.value === this.state.Architecture)}
                                      onChange={(e) => { this.handleChangeArchitecture(e) }} options={this.state.architectureOptions} noValidate></Select>
                                  </FormGroup>
                                </Col>

                              </Row>

                            </div>
                            <hr className="my-4" />

                            {this.state.editFlag && <Row className="stickybuttons">
                              <Col lg="1">

                                <FormGroup>
                                  <br></br>
                                  <br></br>
                                  <Button
                                    color="primary"
                                    size="sm"
                                    onClick={e => this.UpdateAccount()}
                                  >
                                    Update
                                  </Button>
                                </FormGroup>
                              </Col>
                              <Col lg="1">

                                <FormGroup>
                                  <br></br>
                                  <br></br>
                                  <Button
                                    color="primary"
                                    onClick={e => this.DeleceAccount()}
                                    size="sm"
                                  >
                                    Delete
                                  </Button>
                                </FormGroup>
                              </Col>
                              <Col lg="2">
                                <FormGroup>
                                  <br></br>
                                  <br></br>
                                  {this.state.editFlag && <Button
                                    color="primary"
                                    onClick={e => this.LockUnlockUser()}
                                    size="sm"
                                  >
                                    {this.state.lockstatus ? "Temporary Lock" : "Unlock"}
                                  </Button>}
                                </FormGroup>
                              </Col>
                            </Row>}


                            <Row>
                              <Col lg="1">
                                <FormGroup>
                                  <Button
                                    color="secondary"
                                    size="sm"
                                    type="submit"
                                    onClick={this.cancelClick}
                                  >
                                    Cancel
                                  </Button>
                                </FormGroup>
                              </Col>
                              <Col lg="2">
                                <FormGroup>
                                  <Button
                                    color="primary"
                                    size="sm"
                                    type="submit"
                                    onClick={this.CreateNewImageMapping}
                                  >
                                    {this.state.btnActions}
                                  </Button>
                                </FormGroup>
                              </Col>
                            </Row>
                          </Form>
                        </Scrollbars>

                      </div>
                    </CardBody>
                  </Card>
                </div>
              </Row>
            </Col>
          </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default newimagemapping;
